import ReactDOM from "react-dom";
import React, { useState } from "react";
import * as $ from "jquery";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as moment from "moment";
import * as _ from "lodash";
import bootbox from "bootbox";

import { UiUtils } from "../../common/uiUtils";
import { ViewerUtils } from "../../common/viewerUtils";
import { ModelApi } from "../../api/modelApi";
import { viewerOptions, viewerState } from "../../viewer";
import * as SmartDrawings from "../../smartDrawings";
import { Misc } from "../../common/misc";
import { FormField, SelectField } from "../../common/forms";

interface MarkupFormProps {
    viewer: Autodesk.Viewing.GuiViewer3D;
    core: any;
    markup: SmartDrawings.Markup;
    onSubmit: (values) => void;
    onCancel: () => void;
}

interface MarkupFormState {
    name: string;
    editMode: string;
    "stroke-color": string;
}

const RadioButtonField = (props) => {
    return <label className={`btn btn-secondary ${props.values.editMode === props.name ? "active" : ""}`} title={props.label}>
        <input type="radio" name="options" id={props.name} checked={props.values.editMode === props.name} onChange={
            (evt) => {
                props.setValues({ ...props.values, editMode: props.name });
                props.onChangeMode();
            }} /><span className={`icon ${props.icon}`}/>
           </label>;
}

class MarkupForm extends React.Component<MarkupFormProps, MarkupFormState>  {

    constructor(props) {
        super(props);

        this.state = {
            name: this.props.markup.name,
            editMode: "arrow",
            "stroke-color": "#ff0000"
        };

        
        // @ts-ignore
        /*props.core.addEventListener(Autodesk.Viewing.Extensions.Markups.Core.EVENT_MARKUP_SELECTED,
            evt => {
                const markup = this.props.core.getSelection();
                if (markup != null) {
                    
                    this.setState({ "stroke-color": markup.getStyle()["stroke-color"]});
                }
            });
            */
    }

    componentDidMount(): void {
        // @ts-ignore
        this.props.core.addEventListener(Autodesk.Viewing.Extensions.Markups.Core.EVENT_EDITMODE_CHANGED, this.onEditModeChange);
    }

    componentWillUnmount(): void {
        // @ts-ignore
        this.props.core.removeEventListener(Autodesk.Viewing.Extensions.Markups.Core.EVENT_EDITMODE_CHANGED, this.onEditModeChange)
    }

    onEditModeChange = evt => {
        this.setState({ editMode: evt.target.type });
    }

    onFormChange = (values) => {
        this.setState({ name: values.name, "stroke-color": values["stroke-color"] });
        const markup = this.props.core.getSelection();
        const style = markup ? markup.getStyle() : this.props.core.getStyle();
        style["stroke-color"] = values["stroke-color"];
        this.props.core.setStyle(style);
    }

    render() {
        return (
            <Formik
                enableReinitialize={true}
                initialValues={{
                    ...this.state
                }}
                validate={this.onFormChange}
                onSubmit={(values, actions) => {
                    actions.setSubmitting(false);
                    this.props.onSubmit(values);
                }}
                render={({ values, errors, status, touched, isSubmitting, handleReset, setValues }) => (
                    <Form className="container pt-3" style={{ width: "auto" }}>

                        <FormField name="name" label="Name"/>
                        <div className="form-group row">
                        <label className="col-form-label col-sm-3 ">Shape</label>
                            <div className="col-sm-auto">
                            <div className="btn-group btn-group-toggle">
                            <RadioButtonField name="arrow" values={values} setValues={setValues} label="Arrow" icon="ion-md-arrow-forward" onChangeMode={() =>
                                // @ts-ignore
                                this.props.core.changeEditMode(new Autodesk.Viewing.Extensions.Markups.Core.EditModeArrow(this.props.core))}/>
                            <RadioButtonField name="polyline" values={values} setValues={setValues} label="Line" icon="ion-md-remove" onChangeMode={() =>
                                // @ts-ignore
                                this.props.core.changeEditMode(new Autodesk.Viewing.Extensions.Markups.Core.EditModePolyline(this.props.core))}/>
                            <RadioButtonField name="rectangle" values={values} setValues={setValues} label="Rectangle" icon="ion-md-square-outline" onChangeMode={() =>
                                // @ts-ignore
                                this.props.core.changeEditMode(new Autodesk.Viewing.Extensions.Markups.Core.EditModeRectangle(this.props.core))}/>
                            <RadioButtonField name="ellipse" values={values} setValues={setValues} label="Circle" icon="ion-md-radio-button-off" onChangeMode={() =>
                                // @ts-ignore
                                this.props.core.changeEditMode(new Autodesk.Viewing.Extensions.Markups.Core.EditModeCircle(this.props.core))} />
                            <RadioButtonField name="dimension" values={values} setValues={setValues} label="Dimension" icon="ion-md-code-working" onChangeMode={() =>
                                // @ts-ignore
                                this.props.core.changeEditMode(new Autodesk.Viewing.Extensions.Markups.Core.EditModeDimension(this.props.core))} />
                            <RadioButtonField name="label" values={values} setValues={setValues} label="Text" icon="ion-md-text" onChangeMode={() =>
                                // @ts-ignore
                                this.props.core.changeEditMode(new Autodesk.Viewing.Extensions.Markups.Core.EditModeText(this.props.core))} />
                            </div>
                            </div>
                        </div>
                        <SelectField name={"stroke-color"} label="Color" values={[
                            { value: "#ff0000", label: "Red" },
                            { value: "#00ff00", label: "Green" },
                            { value: "#0000ff", label: "Blue" },
                            { value: "#000000", label: "Black" },
                            { value: "#ffffff", label: "White" }]} />
                        <div className="form-group row">
                        <button className="btn btn-primary ml-1" type="button" onClick={() => this.props.core.cut()}>
                            Cut
                        </button>
                        <button className="btn btn-primary ml-1" type="button" onClick={() => this.props.core.copy()}>
                            Copy
                        </button>
                        <button className="btn btn-primary ml-1" type="button" onClick={() => this.props.core.paste()}>
                            Paste
                        </button>
                        <button className="btn btn-warning ml-1" type="button" onClick={() => this.props.core.clear()}>
                                Clear
                        </button>
                        </div>
                        <div className="form-group row ml-1">The model view is locked when viewing markup.
                        </div>
                        <div className="row">
                            <button className="btn btn-success ml-1" type="submit">
                                Save
                            </button>
                            <button className="btn btn-danger ml-1" type="button" onClick={() => this.props.onCancel()}>
                                Discard
                            </button>
                        </div>
                    </Form>
                )}/>
               
                
        );
    }
}

class MarkupPanel extends Autodesk.Viewing.UI.DockingPanel {

    private viewer: Autodesk.Viewing.GuiViewer3D;

    private contentDiv: HTMLDivElement;
    private reactNode;
    private core;

    private markup: SmartDrawings.Markup;
    private onClose: () => void;

    constructor(viewer: Autodesk.Viewing.GuiViewer3D, container: any, id: string, onClose: () => void) {
        super(container, id, "Markup");
        this.viewer = viewer;
        this.onClose = onClose;
        this.container.classList.add("markup-panel");

        this.contentDiv = document.createElement("div");
        this.contentDiv.classList.add("content");
        this.container.appendChild(this.contentDiv);

        this.core = viewer.getExtension("Autodesk.Viewing.MarkupsCore");
        if (this.core == null) {
            viewer.addEventListener(Autodesk.Viewing.EXTENSION_LOADED_EVENT,
                ({extensionId}) => {
                    if (extensionId === "Autodesk.Viewing.MarkupsCore") {
                        this.core = viewer.getExtension("Autodesk.Viewing.MarkupsCore");
                    }
                });
        }
    }

    submitChanges(values) {
        this.markup.name = values.name;
        viewerState.markups[this.markup.id] =
            { ...this.markup, svg: this.core.generateData() };
        this.setVisible(false);
    }

    setMarkupVisible(show: boolean, markup?: SmartDrawings.Markup) {
        this.markup = markup;
        this.setVisible(show);
        if (show) {
            this.core.show();
            if (this.markup != null) {
                this.core.loadMarkups(this.markup.svg, "Layer1");
                this.core.enterEditMode("Layer1");
            } else {
                this.core.enterEditMode();
            }
        } 
    }

    setVisible(show: boolean): void {
        super.setVisible(show);
        if (show) {
            ReactDOM.unmountComponentAtNode(this.contentDiv);
            this.reactNode = ReactDOM.render(<MarkupForm
                viewer={this.viewer}
                core={this.core}
                markup={this.markup}
                onSubmit={(values) => this.submitChanges(values)}
                onCancel={() => this.setVisible(false)}/>, this.contentDiv);
        } else if (this.reactNode) {
            ReactDOM.unmountComponentAtNode(this.contentDiv);
            this.reactNode = null;
            this.core.leaveEditMode();
            this.core.hide();
            this.onClose();
        }
    }
}

export { MarkupPanel };